import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "data-about-prompts": "",
  class: "m-0 list-disc pl-5 text-sm leading-relaxed text-gray-700"
}
const _hoisted_2 = {
  "data-about-note": "",
  class: "m-0 rounded-md bg-gray-100 px-3 py-2 text-[13px] text-gray-600"
}

import { computed } from 'vue'

import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { ABOUT_NOTE, ABOUT_PROMPTS, sectionCopy } from '@/config/agentWizardSteps'


export default {
  __name: 'AgentStepAbout',
  setup(__props) {

const wizard = injectWizard()
const copy = computed(() => sectionCopy('about.context', wizard.data, wizard.ctx))

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(WizardSection, {
    title: copy.value.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ABOUT_PROMPTS), (prompt) => {
          return (_openBlock(), _createElementBlock("li", { key: prompt }, _toDisplayString(prompt), 1))
        }), 128))
      ]),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(wizard).data.about.additional_context) = $event)),
        rows: "6",
        "aria-label": "Things customers ask",
        class: "block w-full rounded-md border border-gray-300 px-2.5 py-2 text-sm leading-5 text-gray-900 shadow-sm"
      }, null, 512), [
        [_vModelText, _unref(wizard).data.about.additional_context]
      ]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(ABOUT_NOTE)), 1)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

}